<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
interface Props {
  modelValue: boolean | undefined
  trueBgColor?: HTMLAttributes['class']
  falseBgColor?: HTMLAttributes['class']
}

interface Emits {
  (e: 'update:modelValue', value: boolean | undefined): void
}

const props = withDefaults(defineProps<Props>(), {
  trueBgColor: 'bg-primary',
  falseBgColor: 'bg-neutral-200',
})
const emit = defineEmits<Emits>()

const toggleSwitch = () => {
  emit('update:modelValue', !props.modelValue)
}
</script>

<template>
  <button type="button" role="switch" :aria-checked="modelValue" :data-state="modelValue ? 'checked' : 'unchecked'"
    :value="modelValue ? 'on' : 'off'"
    class="group/switch block h-5 w-8 shrink-0 p-0.5 outline-none hover:cursor-pointer focus:outline-none"
    @click="toggleSwitch">
    <div
      class="h-4 w-7 rounded-full bg-gray-200 p-0.5 outline-none transition duration-200 ease-out group-hover/switch:bg-neutral-300 group-focus/switch:outline-none group-focus-visible/switch:bg-neutral-300 group-active/switch:bg-neutral-200"
      :class="[
        modelValue ? props.trueBgColor : props.falseBgColor,
      ]">
      <span :data-state="modelValue ? 'checked' : 'unchecked'"
        class="after:shadow-switch-thumb pointer-events-none relative block size-3 transition-transform duration-200 ease-out before:absolute before:inset-y-0 before:left-1/2 before:w-3 before:-translate-x-1/2 before:rounded-full before:bg-white before:[mask:--mask] after:absolute after:inset-y-0 after:left-1/2 after:w-3 after:-translate-x-1/2 after:rounded-full group-active/switch:scale-[.833] data-[state=checked]:translate-x-3"
        :style="{
          '--mask':
            'radial-gradient(circle farthest-side at 50% 50%, #0000 1.95px, #000 2.05px 100%) 50% 50%/100% 100% no-repeat'
        }"></span>
    </div>
  </button>
</template>



<style scoped>
/* Custom CSS variables for the switch thumb shadow if needed */
:root {
  --shadow-switch-thumb:
    0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}
</style>
